import React,{useState} from "react";
import { Button, message,Checkbox, Modal, Col } from "antd";
import { handleBlockByAdminSeats } from './block-by-admin.module';
import { isValid, isValidArray,checkActionAllowed } from "../../utils/utilities";
import { ACTION_BLOCK_BY_ADMIN_SEATS_ALLOWED, ACTION_PERMANENT_ADMIN_BLOCK } from './../../utils/constant';
import './block-by-admin.style.scss';

export const BlockByAdminComponent = (props) => {

    const{
        selectedSchedule,
        selectedSeats,
        onSuccess,
        disableAdminBlock,
        checkTripActionAllowed
    }=props;

    // Cross operator trips pass the sharing agent's action check; own trips use the logged in user's
    const checkAction = isValid(checkTripActionAllowed)?checkTripActionAllowed:checkActionAllowed;

    const [isPermanentBlock,setIsPermanentBlock] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onFailure=()=>{
        message.error("Failed to block trips!")
    }

    const handleOk = () => {
        if(isValidArray(selectedSchedule)&&isValidArray(selectedSchedule.trip)&&isValid(selectedSchedule.trip.id)){
            let tripId=selectedSchedule.trip.id;
            let tripRouteId = selectedSchedule.trip_route_id;
            handleBlockByAdminSeats(tripId,tripRouteId,selectedSeats,isPermanentBlock,onSuccess,onFailure);
        }else{
            message.error("Trip not selected!")
        }
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    }
    
    if(checkAction(ACTION_BLOCK_BY_ADMIN_SEATS_ALLOWED)){
        return (
            <Col>
                <Button onClick={()=>setIsModalOpen(true)} disabled={disableAdminBlock} className="admin-block">
                    Admin Block
                </Button>
                <Modal visible={isModalOpen} title="Block Seats" onOk={handleOk} onCancel={handleCancel} cancelButtonProps={{className:"exit-btn"}} >
                    <div>
                        <span>Are you sure to block seats?</span>
                        {checkAction(ACTION_PERMANENT_ADMIN_BLOCK)&&<div style={{ marginTop: '10px' }}>
                            <Checkbox
                                checked={isPermanentBlock}
                                onChange={(e) => setIsPermanentBlock(e.target.checked)}
                            >
                                Permanent Block
                            </Checkbox>
                        </div>}
                    </div>
                </Modal>
            </Col>
        )
    }else{
        return null
    }
}